// ============================================================================
// text-sanitize.js — stripJuristic
// ------------------------------------------------------------
// ตัดคำว่า "นิติบุคคล" (และคำสะกดผิด "นิติบุคล") ออกจากข้อความที่แสดงบนหน้าเว็บขาย
// (public landing page) เป็นชั้นป้องกันเพิ่มเติมจาก response ฝั่ง backend
// เผื่อข้อมูลมาจากแหล่งอื่นที่ backend ยังไม่ได้กรอง
//
// ★ ตัดคำเชื่อม (จาก/ของ/กับ/โดย/คือ/เป็น) เฉพาะตัวที่ "ติดหน้า" คำว่านิติบุคคลเท่านั้น
//   "ข้อมูลตรงจากนิติบุคคล ตรวจสอบ..." → "ข้อมูลตรง ตรวจสอบ..." (ไม่เหลือ "จาก" ค้าง)
//   เดิมพอเจอคำว่านิติบุคคลที่ไหนสักแห่ง จะไล่ตัดคำเชื่อมท้าย "ทุกกลุ่มคำ" ทั้งข้อความ
//   "ห้องมีที่เก็บของ ติดต่อนิติบุคคลได้" เลยกลายเป็น "ห้องมีที่เก็บ ติดต่อได้" (ของหาย)
// ★ algorithm เดียวกับ CDS-P2-Backend/utils/strip-juristic.js — แก้ที่หนึ่งต้องแก้อีกที่ด้วย
// ============================================================================

const JURISTIC_PATTERN = /(จาก|ของ|กับ|โดย|คือ|เป็น)?นิติบุคค?ล/g;

export const stripJuristic = (input) => {
    if (typeof input !== "string" || !input) return input;

    // ไม่มีคำนี้ = คืนค่าเดิมทั้งก้อน (ไม่ไปยุ่งช่องว่าง/บรรทัดของข้อความที่ไม่เกี่ยว)
    JURISTIC_PATTERN.lastIndex = 0;
    if (!JURISTIC_PATTERN.test(input)) return input;

    return (
        input
            .replace(JURISTIC_PATTERN, "")
            // เก็บกวาดช่องว่างที่เหลือจากการตัดคำ — คงการขึ้นบรรทัดไว้ (รายละเอียดห้องใช้ pre-line)
            .replace(/[ \t]+/g, " ")
            .replace(/ *\n */g, "\n")
            .trim()
    );
};

export default stripJuristic;
